import { animate, style, transition, trigger } from '@angular/animations';

import { Component, Input, NgZone, OnChanges } from '@angular/core';
import { debounce } from '../../../lib/debounce';
import { sleep } from '../../../lib/sleep';

@Component({
  selector: 'app-route-loader',
  templateUrl: './route-loader.component.html',
  styleUrls: ['./route-loader.component.scss'],
  animations: [
    trigger('loader', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-15px)' }),
        animate('0.2s ease', style({ opacity: 1, transform: 'translateY(0px)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateY(0px)' }),
        animate('0.5s ease', style({ opacity: 0, transform: 'translateY(-15px)' })),
      ]),
    ]),
  ],
  standalone: true,
  imports: [],
})
export class RouteLoaderComponent implements OnChanges {
  @Input() active: boolean;
  public showLoader = false;
  public _showLoader = false;
  public width = 0;
  private loadingStart: number;

  constructor(private zone: NgZone) {}

  async ngOnChanges() {
    this._showLoader = this.active;

    if (this.active) {
      this.zone.runOutsideAngular(() => {
        this.startLoadingDebouced();
      });
    } else if (this.showLoader) {
      this.width = 100;
      this.loadingStart = undefined;
      await sleep(100);
      this.showLoader = false;
    }
  }

  startLoadingDebouced = debounce(() => {
    if (!this._showLoader) return;
    this.zone.run(() => {
      const loadingStart = Date.now();
      this.loadingStart = loadingStart;
      this.showLoader = true;
      this.startLoading(loadingStart);
    });
  }, 250);

  startLoading(loadingStart: number) {
    const updateLoading = async (delay: number) => {
      await sleep(delay);
      if (loadingStart !== this.loadingStart) return;
      const left = 97 - this.width;
      this.width += left / 70;
      updateLoading(delay);
    };

    this.width = 0;
    updateLoading(16);
  }
}
